import { render, staticRenderFns } from "./ItemBaseRate.vue?vue&type=template&id=0fe43389&scoped=true&"
import script from "./ItemBaseRate.vue?vue&type=script&lang=js&"
export * from "./ItemBaseRate.vue?vue&type=script&lang=js&"
import style0 from "./ItemBaseRate.vue?vue&type=style&index=0&id=0fe43389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe43389",
  null
  
)

export default component.exports